import { render, staticRenderFns } from "./CreateRunShipmentModal.vue?vue&type=template&id=651098c3&scoped=true&"
import script from "./CreateRunShipmentModal.vue?vue&type=script&lang=js&"
export * from "./CreateRunShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateRunShipmentModal.vue?vue&type=style&index=0&id=651098c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651098c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('651098c3')) {
      api.createRecord('651098c3', component.options)
    } else {
      api.reload('651098c3', component.options)
    }
    module.hot.accept("./CreateRunShipmentModal.vue?vue&type=template&id=651098c3&scoped=true&", function () {
      api.rerender('651098c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RunSchedules/components/CreateRunShipmentModal.vue"
export default component.exports